import{a as r}from"./chunk-IEE7G5JG.js";import{a as n}from"./chunk-ANXBDSUI.js";function l(...e){return r(i,e)}var i=e=>(t,a,o)=>o.findIndex(u=>e(t,u))===a?{done:!1,hasNext:!0,next:t}:n;export{l as a};
